import React, { useEffect, useMemo, useState } from 'react';

import { CustomButton } from '@components/Styles/ButtonStyle';
import { CustomStack } from '@components/Styles/CommonStyle';
import PlannedProjectCreateTable from '@components/common/Table/PlannedProjectCreateTable';
import api from '@api/axios';
import moment from 'moment';
import { useDialog } from '@context/DialogContext';
import { useLoading } from '@context/LoadingContext';
import { useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';

const PlannedProjectCreate = () => {
  const { showLoading, hideLoading } = useLoading();
  const { showDialog } = useDialog();

  const navigate = useNavigate();

  // 프로젝트 ID
  const id = new URLSearchParams(window.location.search).get('id') || null;
  console.log('프로젝트ID : ' + id);

  const [projectInfo, setProjectInfo] = useState({
    name: '',
    amount: '',
    orderingCompany: '',
    accountCompany: '',
    projectManager: '',
  });

  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [commentList, setCommentList] = useState([]);
  const [comment, setComment] = useState('');
  const [commentListEditFlag, setCommentListEditFlag] = useState([]);

  const [searchOrderingCompanyList, setSearchOrderingCompanyList] = useState([]);
  const [searchAccountCompanyList, setSearchAccountCompanyList] = useState([]);

  // 디바운스 함수 : 발주사 검색
  const debouncedSearchOrderingCompany = useMemo(
    () =>
      debounce((name) => {
        onSearchOrderingCompany(name);
      }, 300),
    [],
  );

  // 디바운스 함수 : 거래처 검색
  const debouncedSearchAccountCompany = useMemo(
    () =>
      debounce((name) => {
        onSearchAccountCompany(name);
      }, 300),
    [],
  );

  // 발주사 검색
  const onSearchOrderingCompany = (name) => {
    const accountType = '법인사업자';

    api
      .get(
        `/api/account/readAccountList?${accountType ? `&accountType=${accountType}` : ''}${name ? `&name=${name}` : ''}`,
      )
      .then((res) => {
        const list = res.data.result.rows;

        const orderingCompanyList = list.map((item) => {
          return item.company_name;
        });

        setSearchOrderingCompanyList(orderingCompanyList);
      });
  };

  // 거래처 검색
  const onSearchAccountCompany = (name) => {
    const accountType = '법인사업자';

    api
      .get(
        `/api/account/readAccountList?${accountType ? `&accountType=${accountType}` : ''}${name ? `&name=${name}` : ''}`,
      )
      .then((res) => {
        const list = res.data.result.rows;

        const accountCompanyList = list.map((item) => {
          return item.company_name;
        });

        setSearchAccountCompanyList(accountCompanyList);
      });
  };

  const handleSave = () => {
    // 사업정보 입력 확인
    console.log('projectInfo');
    console.log(projectInfo);
    if (
      projectInfo.name === '' ||
      projectInfo.amount === '' ||
      projectInfo.orderingCompany === '' ||
      projectInfo.accountCompany === '' ||
      projectInfo.projectManager === '' ||
      startDate === '' ||
      endDate === ''
    ) {
      showDialog({ title: '확인', message: '사업정보를 입력해 주세요.' });
      return;
    }

    // 신규 시 신규 프로젝트 등록, 수정 시 수정
    let url = null;
    if (id) url = `/api/project/updatePlannedProject?id=${id}`;
    else url = '/api/project/createPlannedProject';

    showLoading();
    api
      .post(url, { projectInfo, startDate, endDate })
      .then((res) => {
        console.log('res');
        console.log(res);
        if (res.status === 201) {
          navigate('/project/plannedProjectList');
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    if (id) {
      api.get(`/api/project/readProject?id=${id}`).then((res) => {
        console.log('res');
        console.log(res);

        if (res.status === 200) {
          setProjectInfo(res.data.projectInfo);
          setStartDate(res.data.projectInfo.startDate);
          setEndDate(res.data.projectInfo.endDate);
        }
      });
    }
  }, [id]);

  // 댓글 탭으로 이동하는 경우 댓글 섹션으로 스크롤
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');
    
    if (tabParam === 'comment' && id) {
      // DOM 렌더링 완료 후 댓글 섹션으로 스크롤
      setTimeout(() => {
        const commentSection = document.querySelector('[data-section="comment"]');
        if (commentSection) {
          commentSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500);
    }
  }, [id]);

  // 발주사 검색
  useEffect(() => {
    console.log('projectInfo.orderingCompany');

    debouncedSearchOrderingCompany(projectInfo.orderingCompany);

    return () => {
      debouncedSearchOrderingCompany.cancel();
    };
  }, [projectInfo.orderingCompany]);

  // 거래처 검색
  useEffect(() => {
    console.log('projectInfo.accountCompany');

    debouncedSearchAccountCompany(projectInfo.accountCompany);

    return () => {
      debouncedSearchAccountCompany.cancel();
    };
  }, [projectInfo.accountCompany]);


  return (
    <React.Fragment>
      <PlannedProjectCreateTable
        projectInfo={projectInfo}
        setProjectInfo={setProjectInfo}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        id={id}
        comment={comment}
        setComment={setComment}
        commentList={commentList}
        setCommentList={setCommentList}
        commentListEditFlag={commentListEditFlag}
        setCommentListEditFlag={setCommentListEditFlag}
        searchOrderingCompanyList={searchOrderingCompanyList}
        searchAccountCompanyList={searchAccountCompanyList}
      />

      <CustomStack justifyContent="center" mt={4}>
        <CustomButton color="gray" onClick={() => navigate('/project/plannedProjectList')}>
          취소
        </CustomButton>
        {id ? (
          <CustomButton onClick={handleSave}>수정</CustomButton>
        ) : (
          <CustomButton onClick={handleSave}>저장</CustomButton>
        )}
      </CustomStack>
    </React.Fragment>
  );
};

export default PlannedProjectCreate;
